import React, {useState, useCallback} from "react"
import nprogress from "nprogress"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import useAuth from "auth/useAuth"
import useValues from "hooks/useValues"
import "./Wiki.css"

export default function Wiki(props) {

    const {admin} = useAuth()
    const {page} = props
    const className = props.className ?? ''
    const category = 'wiki'
    const placeholder = props.placeholder ?? "Markdown tekst..."
    const values = useValues(category)
    const [text, setText] = useState("")
    const [editing, setEditing] = useState(false)
    

    const save = useCallback(() => {
        nprogress.start()
        values.set(page, text, () => {
            nprogress.done()
            setEditing(false)
        }, () => {
            nprogress.done()
        })
    }, [values, page, text])
    
    
    const edit = () => {
        setText(values.get(page, ''))
        setEditing(true)
    }
    
    const cancel = () => {
        setEditing(false)
    }
    
    if (!admin && values.isEmpty(page)) return
    
    return <section className={`wiki ${page} ${className}`} id={`wiki-${page}`}>
        
        {!editing && <ReactMarkdown className="content" rehypePlugins={[rehypeRaw]}>{values.get(page, '')}</ReactMarkdown>}        
        
        {admin && editing && <div className="roster-note-edit">
            <div className="buttons">
                <button onClick={save} className="btn btn-primary btn-sm">Snimi</button>
                <button onClick={cancel} className="btn btn-light btn-sm">Poništi</button>
            </div>
            <textarea rows={15} value={text} placeholder={placeholder} onChange={e => setText(e.target.value)}/>
            <div className="buttons">
                <button onClick={save} className="btn btn-primary btn-sm">Snimi</button>
                <button onClick={cancel} className="btn btn-light btn-sm">Poništi</button>
            </div>
        </div>}

        {!editing && admin && <div className="buttons">
            <button onClick={edit} className="btn btn-primary btn-sm">Izmeni</button>
        </div>}
                
    </section>

}